import { SET_SETTLEMENT_WORKBENCH_DATA, CLEAR_SETTLEMENT_WORKBENCH_DATA } from '../actions/settlementWorkbenchAction';

const initialState = {
    records: [],
    totalRecords: 0
};

const SettlementWorkbenchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SETTLEMENT_WORKBENCH_DATA:{
            let records = [];
            records = action.payload.Results;

            return Object.assign({}, state, {
                records,
                totalRecords: action.payload.totalCount
            });
        }
        case CLEAR_SETTLEMENT_WORKBENCH_DATA:
            return Object.assign({}, state, {
                records: [],
                totalRecords: 0
            });

        default:
            return state;
    }
};

export default SettlementWorkbenchReducer;
